export default "__VITE_ASSET__8db07a44__"